import React, { useState, useRef } from 'react';
import ContactModal from '../components/ContactModal';

function Contact() {
  const [open, setOpen] = useState(false);
  const buttonRef = useRef(null);

  return (
    <section id="contact" className="py-16 px-4 max-w-4xl mx-auto text-center reveal" aria-labelledby="contact-title" style={{ transitionDelay: '0.18s' }}>
      <h2 id="contact-title" className="text-3xl font-bold mb-8">Get In Touch</h2>
      <p className="text-lg mb-4">I’m currently open to junior front-end opportunities and would love to work on real-world projects.</p>
      <p className="mb-4">Email: <a href="mailto:ahmed.barbarycloud@icloud.com" className="text-neon underline hover:no-underline focus:outline-none focus:ring-2 focus:ring-neon">ahmed.barbarycloud@icloud.com</a></p>

      <div className="flex justify-center gap-4">
        <button ref={buttonRef} onClick={() => setOpen(true)} className="px-4 py-2 border-2 border-neon neon-glow hover:bg-neon hover:text-black">Contact Me</button>
        <a href="/resume.pdf" className="px-4 py-2 border-2 border-neon neon-glow hover:bg-neon hover:text-black" target="_blank" rel="noopener noreferrer" download>Download Resume</a>
      </div>

      <ContactModal open={open} onClose={() => setOpen(false)} returnFocusRef={buttonRef} />
    </section>
  );
}

export default Contact;